
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.037 12.302a3.88 3.88 0 01-.567 2.028 3.92 3.92 0 01-6.724 0 3.859 3.859 0 01-.576-2.028 3.934 3.934 0 117.867 0z","fill":"none","stroke":"#808185","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('g',{attrs:{"fill":"none","stroke":"#808185","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"data-name":"Vector","d":"M15.545 12.278h-2.94M14.071 10.845v2.94"}})]),_c('g',{attrs:{"data-name":"Group"}},[_c('path',{attrs:{"data-name":"Vector","d":"M17.259 3.341v1.853a3.19 3.19 0 01-.844 1.944l-1.474 1.293a3.7 3.7 0 00-.869-.1 3.969 3.969 0 00-3.968 3.963 3.907 3.907 0 00.576 2.044 3.741 3.741 0 001.261 1.277v.284a1.86 1.86 0 01-.76 1.435l-1.178.759a1.719 1.719 0 01-2.618-1.437v-4.462a3.26 3.26 0 00-.677-1.769L3.501 7.056a2.841 2.841 0 01-.76-1.687V3.425a1.712 1.712 0 011.687-1.769h11.144a1.692 1.692 0 011.687 1.685z","fill":"none","stroke":"#808185","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])])
          )
        }
      }
    